import { render, staticRenderFns } from "./ChainAgentInfomation.vue?vue&type=template&id=639d4e45&scoped=true"
import script from "./ChainAgentInfomation.vue?vue&type=script&lang=js"
export * from "./ChainAgentInfomation.vue?vue&type=script&lang=js"
import style0 from "./ChainAgentInfomation.vue?vue&type=style&index=0&id=639d4e45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d4e45",
  null
  
)

export default component.exports